import React from 'react';
import { Group, Line, Rect, Text, Image, Circle, Stage, Layer } from 'react-konva';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

const schematicOrange = "#ff5a1f";
class MeasurementLine extends React.Component {
  render() {
    let clickHandler = () => {
      if (this.props.showModal) this.props.showModal(this.props.label, this.props.length, this.inputChanged.bind(this), this.props.minValue, this.props.maxValue);
    };
    let element = /*#__PURE__*/React.createElement(Group, {
      ref: node => this.root = node,
      rotation: this.props.rotation,
      x: this.props.startx,
      y: this.props.starty,
      preventDefault: false
    }, /*#__PURE__*/React.createElement(Line, {
      ref: mainLine => {
        this.mainLine = mainLine;
      },
      stroke: schematicOrange,
      strokeWidth: 5,
      points: [0, -50 / 2, this.props.length, -50 / 2]
    }), /*#__PURE__*/React.createElement(Line, {
      ref: startLine => {
        this.startLine = startLine;
      },
      stroke: schematicOrange,
      strokeWidth: 5,
      points: [0, -50, 0, 0]
    }), /*#__PURE__*/React.createElement(Line, {
      ref: endLine => {
        this.endLine = endLine;
      },
      stroke: schematicOrange,
      strokeWidth: 5,
      points: [this.props.length, -50, this.props.length, 0]
    }), /*#__PURE__*/React.createElement(Group, {
      x: this.startPosition(),
      y: -112,
      onTap: clickHandler,
      onClick: clickHandler
    }, /*#__PURE__*/React.createElement(Rect, {
      width: this.neededWidth(),
      height: 90,
      fill: "#f3f1ec",
      cornerRadius: 18
    }), /*#__PURE__*/React.createElement(Text, {
      x: 0,
      y: 8,
      width: this.neededWidth(),
      align: "center",
      fill: "#202020",
      ref: text => {
        this.text = text;
      },
      fontSize: 76,
      text: this.props.length + " mm"
    })));
    return element;
  }
  setLength(length, moveStartPoint) {
    this.text.text(length + " mm");
    let mainLinePoints = this.mainLine.points();
    if (moveStartPoint) {
      let lengthChange = mainLinePoints[2] - length;
      let startLinePoints = this.startLine.points();
      startLinePoints[0] = lengthChange;
      startLinePoints[2] = lengthChange;
      this.startLine.points(startLinePoints);
      mainLinePoints[0] = lengthChange;
    } else {
      mainLinePoints[2] = length;
      let endLinePoints = this.endLine.points();
      endLinePoints[0] = length;
      endLinePoints[2] = length;
      this.endLine.points(endLinePoints);
    }
    this.mainLine.points(mainLinePoints);
  }
  inputChanged(value) {
    if (this.props.lengthInputChanged) {
      this.props.lengthInputChanged(value);
    }
  }
  convertToAbsolutePosition(pos) {
    return this.root.getAbsoluteTransform().point(pos);
  }
  neededWidth() {
    let length = this.props.length < 1000 ? 390 : 440;
    return length;
  }
  startPosition() {
    let start = this.props.length / 2 - this.neededWidth() / 2;
    if (this.props.avoidOverFlow) start = Math.max(0, start);
    return start;
  }
  editIcon(props) {
    if (!this.props.readOnly) return /*#__PURE__*/React.createElement(URLImage, {
      y: 10,
      x: this.neededWidth() - 90,
      src: props.penIcon || "img/pen.png"
    });
  }
}

let URLImage$1 = class URLImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null
    };
  }
  componentDidMount() {
    this.loadImage();
  }
  componentDidUpdate(oldProps) {
    if (oldProps.src !== this.props.src) {
      this.loadImage();
    }
  }
  componentWillUnmount() {
    this.image.removeEventListener('load', this.handleLoad.bind(this));
  }
  loadImage() {
    this.image = new window.Image();
    this.image.src = this.props.src;
    this.image.addEventListener('load', this.handleLoad.bind(this));
  }
  handleLoad() {
    this.setState({
      image: this.image
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(Image, {
      x: this.props.x,
      y: this.props.y,
      width: this.props.width,
      height: this.props.height,
      image: this.state.image,
      dragBoundFunc: this.props.dragBoundFunc,
      onDragEnd: this.props.onDragEnd,
      onTap: this.props.onTap,
      onClick: this.props.onClick,
      draggable: this.props.draggable,
      offsetX: this.props.offsetX,
      offsetY: this.props.offsetY,
      ref: node => {
        this.imageNode = node;
      }
    });
  }
};

const glassEdgeColor = '#76898b';
const metalMidTone = '#90999a';
function isDarkMetalTone(tone) {
  const normalized = String(tone || '').trim().toLowerCase().replace(/\s/g, '');
  if (normalized === 'black') return true;
  const hexMatch = normalized.match(/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i);
  if (hexMatch) {
    let hex = hexMatch[1];
    if (hex.length === 3) hex = hex.split('').map(value => value + value).join('');
    const red = parseInt(hex.slice(0, 2), 16);
    const green = parseInt(hex.slice(2, 4), 16);
    const blue = parseInt(hex.slice(4, 6), 16);
    return red * 0.2126 + green * 0.7152 + blue * 0.0722 < 72;
  }
  const rgbMatch = normalized.match(/^rgba?\((\d+),(\d+),(\d+)/);
  if (rgbMatch) {
    const [, red, green, blue] = rgbMatch.map(Number);
    return red * 0.2126 + green * 0.7152 + blue * 0.0722 < 72;
  }
  return false;
}
function GlassPane(_ref) {
  let {
    x,
    y,
    width,
    height,
    color,
    nodeRef
  } = _ref;
  const safeWidth = Math.max(0, Number(width));
  const safeHeight = Math.max(0, Number(height));
  const highlightWidth = Math.max(12, Math.min(55, safeWidth * 0.09));
  const normalizedColor = String(color || '').trim().toLowerCase().replace(/\s/g, '');
  const isClearGlass = ['white', '#fff', '#ffffff', 'transparent', 'rgba(0,0,0,0)'].includes(normalizedColor);
  const tintColor = isClearGlass ? '#ffffff' : color || '#526260';
  const tintOpacity = isClearGlass ? 0.06 : 0.48;
  return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(Rect, {
    ref: nodeRef,
    x: x,
    y: y,
    width: safeWidth,
    height: safeHeight,
    fillLinearGradientStartPoint: {
      x: 0,
      y: 0
    },
    fillLinearGradientEndPoint: {
      x: safeWidth,
      y: safeHeight
    },
    fillLinearGradientColorStops: [0, 'rgba(21, 29, 29, 0.16)', 0.42, 'rgba(68, 79, 76, 0.04)', 0.72, 'rgba(29, 38, 37, 0.1)', 1, 'rgba(13, 20, 20, 0.18)'],
    shadowColor: "rgba(10, 15, 15, 0.48)",
    shadowBlur: 14,
    shadowOffset: {
      x: 3,
      y: 5
    }
  }), /*#__PURE__*/React.createElement(Rect, {
    x: x,
    y: y,
    width: safeWidth,
    height: safeHeight,
    fill: tintColor,
    opacity: tintOpacity,
    stroke: glassEdgeColor,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement(Rect, {
    x: x + safeWidth * 0.16,
    y: y + 18,
    width: highlightWidth,
    height: Math.max(0, safeHeight - 36),
    fillLinearGradientStartPoint: {
      x: 0,
      y: 0
    },
    fillLinearGradientEndPoint: {
      x: highlightWidth,
      y: 0
    },
    fillLinearGradientColorStops: [0, 'rgba(255,255,255,0)', 0.5, 'rgba(255,255,255,0.16)', 1, 'rgba(255,255,255,0)'],
    listening: false
  }), /*#__PURE__*/React.createElement(Line, {
    points: [x + safeWidth * 0.58, y + 20, x + safeWidth * 0.35, y + safeHeight - 20],
    stroke: "rgba(220, 235, 232, 0.11)",
    strokeWidth: Math.max(8, safeWidth * 0.025),
    lineCap: "round",
    listening: false
  }));
}
function MetalRail(_ref2) {
  let {
    x,
    y,
    width,
    height,
    tone = metalMidTone,
    startMiter,
    endMiter
  } = _ref2;
  const horizontal = width >= height;
  const darkFinish = isDarkMetalTone(tone);
  const railThickness = horizontal ? height : width;
  const railPoints = horizontal ? [x + (startMiter === 'top' ? railThickness : 0), y, x + width - (endMiter === 'top' ? railThickness : 0), y, x + width - (endMiter === 'bottom' ? railThickness : 0), y + height, x + (startMiter === 'bottom' ? railThickness : 0), y + height] : [x, y + (startMiter === 'left' ? railThickness : 0), x + width, y + (startMiter === 'right' ? railThickness : 0), x + width, y + height - (endMiter === 'right' ? railThickness : 0), x, y + height - (endMiter === 'left' ? railThickness : 0)];
  const hasStartMiter = Boolean(startMiter);
  const hasEndMiter = Boolean(endMiter);
  return /*#__PURE__*/React.createElement(Group, {
    listening: false
  }, /*#__PURE__*/React.createElement(Line, {
    points: railPoints,
    closed: true,
    fillLinearGradientStartPoint: {
      x,
      y
    },
    fillLinearGradientEndPoint: horizontal ? {
      x,
      y: y + height
    } : {
      x: x + width,
      y
    },
    fillLinearGradientColorStops: darkFinish ? [0, '#262828', 0.24, '#111212', 0.5, tone, 0.78, '#1d1f1f', 1, '#090a0a'] : [0, '#687173', 0.2, '#c7cccb', 0.44, tone, 0.74, '#b7bdbc', 1, '#596264'],
    shadowColor: "rgba(18, 22, 22, 0.5)",
    shadowBlur: darkFinish ? 3 : 5,
    shadowOffset: {
      x: 1,
      y: 2
    }
  }), /*#__PURE__*/React.createElement(Line, {
    points: horizontal ? [x + (hasStartMiter ? railThickness : 5), y + Math.max(3, height * 0.2), x + width - (hasEndMiter ? railThickness : 5), y + Math.max(3, height * 0.2)] : [x + Math.max(3, width * 0.2), y + (hasStartMiter ? railThickness : 5), x + Math.max(3, width * 0.2), y + height - (hasEndMiter ? railThickness : 5)],
    stroke: darkFinish ? 'rgba(255,255,255,0.09)' : 'rgba(255,255,255,0.28)',
    strokeWidth: darkFinish ? 1 : 1.5
  }));
}
function MiterJoint(_ref3) {
  let {
    points
  } = _ref3;
  return /*#__PURE__*/React.createElement(Group, {
    listening: false
  }, /*#__PURE__*/React.createElement(Line, {
    points: points,
    stroke: "rgba(38,45,46,0.82)",
    strokeWidth: 4,
    lineCap: "round"
  }), /*#__PURE__*/React.createElement(Line, {
    points: points,
    stroke: "rgba(255,255,255,0.42)",
    strokeWidth: 1.5,
    lineCap: "round",
    offsetX: 2
  }));
}
function ChromeHardware(_ref4) {
  let {
    x,
    y,
    width,
    height,
    tone = metalMidTone,
    split = false,
    fasteners = false
  } = _ref4;
  const darkFinish = isDarkMetalTone(tone);
  return /*#__PURE__*/React.createElement(Group, {
    listening: false
  }, /*#__PURE__*/React.createElement(Rect, {
    x: x + 4,
    y: y + 5,
    width: width,
    height: height,
    cornerRadius: 8,
    fill: "rgba(0,0,0,0.34)"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: x,
    y: y,
    width: width,
    height: height,
    cornerRadius: 8,
    fillLinearGradientStartPoint: {
      x: 0,
      y: 0
    },
    fillLinearGradientEndPoint: {
      x: width,
      y: height
    },
    fillLinearGradientColorStops: darkFinish ? [0, '#292b2b', 0.25, tone, 0.52, '#171818', 0.8, tone, 1, '#080909'] : [0, '#d9dddc', 0.24, tone, 0.52, '#c6cbca', 0.8, tone, 1, '#586163'],
    stroke: darkFinish ? '#090a0a' : '#596365',
    strokeWidth: 3
  }), split && /*#__PURE__*/React.createElement(Line, {
    points: [x + width / 2, y + 6, x + width / 2, y + height - 6],
    stroke: darkFinish ? '#050606' : 'rgba(55,62,63,0.72)',
    strokeWidth: 3
  }), fasteners && /*#__PURE__*/React.createElement(Circle, {
    x: x + (split ? width * 0.25 : width * 0.5),
    y: y + height / 2,
    radius: 5,
    fill: darkFinish ? '#080909' : '#4e585a',
    stroke: darkFinish ? '#3a3d3d' : '#d7dcdb',
    strokeWidth: 2
  }), fasteners && split && /*#__PURE__*/React.createElement(Circle, {
    x: x + width * 0.75,
    y: y + height / 2,
    radius: 5,
    fill: darkFinish ? '#080909' : '#4e585a',
    stroke: darkFinish ? '#3a3d3d' : '#d7dcdb',
    strokeWidth: 2
  }));
}
function ChromeHinge(_ref5) {
  let {
    x,
    y,
    width,
    height,
    tone = metalMidTone,
    half = false
  } = _ref5;
  return /*#__PURE__*/React.createElement(ChromeHardware, {
    x: x,
    y: y,
    width: width,
    height: height,
    tone: tone,
    split: !half,
    fasteners: true
  });
}
function ChromeKnob(_ref6) {
  let {
    x,
    y,
    tone = metalMidTone
  } = _ref6;
  const darkFinish = isDarkMetalTone(tone);
  return /*#__PURE__*/React.createElement(Group, {
    listening: false
  }, /*#__PURE__*/React.createElement(Circle, {
    x: x + 4,
    y: y + 5,
    radius: 27,
    fill: "rgba(0,0,0,0.42)"
  }), /*#__PURE__*/React.createElement(Circle, {
    x: x,
    y: y,
    radius: 26,
    fillRadialGradientStartPoint: {
      x: -8,
      y: -9
    },
    fillRadialGradientStartRadius: 2,
    fillRadialGradientEndPoint: {
      x: 0,
      y: 0
    },
    fillRadialGradientEndRadius: 28,
    fillRadialGradientColorStops: darkFinish ? [0, '#414444', 0.25, '#252727', 0.6, tone, 0.84, '#171818', 1, '#070808'] : [0, '#e3e7e6', 0.25, '#c5cac9', 0.6, tone, 0.84, '#d7dcdb', 1, '#515a5c'],
    stroke: darkFinish ? '#080909' : '#515b5d',
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement(Circle, {
    x: x - 8,
    y: y - 9,
    radius: 4,
    fill: darkFinish ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.42)'
  }));
}
function DragHandle(_ref7) {
  let {
    x,
    y,
    axis,
    dragBoundFunc,
    onDragEnd
  } = _ref7;
  const orange = '#ff5a1f';
  const horizontal = axis === 'horizontal';
  const setCursor = (event, cursor) => {
    const stage = event.target.getStage();
    if (stage) stage.container().style.cursor = cursor;
  };
  return /*#__PURE__*/React.createElement(Group, {
    x: x,
    y: y,
    draggable: true,
    dragBoundFunc: dragBoundFunc,
    onDragEnd: onDragEnd,
    onMouseEnter: event => setCursor(event, horizontal ? 'ew-resize' : 'ns-resize'),
    onMouseLeave: event => setCursor(event, 'default')
  }, /*#__PURE__*/React.createElement(Circle, {
    radius: 90,
    fill: "rgba(255,255,255,0.96)",
    stroke: "#6d787a",
    strokeWidth: 5,
    shadowColor: "rgba(0,0,0,0.38)",
    shadowBlur: 12,
    shadowOffset: {
      x: 3,
      y: 5
    }
  }), /*#__PURE__*/React.createElement(Circle, {
    radius: 80,
    fill: "rgba(246,248,247,0.92)",
    stroke: orange,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement(Line, {
    points: horizontal ? [-42, 0, 42, 0] : [0, -42, 0, 42],
    stroke: orange,
    strokeWidth: 9,
    lineCap: "round"
  }), /*#__PURE__*/React.createElement(Line, {
    points: horizontal ? [-54, 0, -27, -21, -27, 21] : [0, -54, -21, -27, 21, -27],
    closed: true,
    fill: orange
  }), /*#__PURE__*/React.createElement(Line, {
    points: horizontal ? [54, 0, 27, -21, 27, 21] : [0, 54, -21, 27, 21, 27],
    closed: true,
    fill: orange
  }));
}

class door extends React.Component {
  constructor(props) {
    super();
  }
  render() {
    let measurements = this.props.measurements;
    this.listColor = this.props.listColor || defaultListColor$2;
    return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(GlassPane, {
      nodeRef: doorGlass => {
        this.doorGlass = doorGlass;
      },
      width: measurements.doorWidth,
      height: measurements.doorHeight,
      y: this.doorFromCeiling(measurements),
      x: measurements.doorFromLeft,
      color: this.props.color
    }), /*#__PURE__*/React.createElement(UpGlass, {
      upGlassEnabled: measurements.upGlassEnabled,
      width: measurements.doorWidth,
      height: measurements.upGlassHeight,
      fromLeft: measurements.doorFromLeft,
      color: this.props.color,
      allowAddOrRemoveGlass: this.props.allowAddOrRemoveGlass,
      allowAddOrRemoveUpGlass: this.props.allowAddOrRemoveUpGlass,
      addGlass: this.props.addGlass,
      removeGlass: this.props.removeGlass,
      onToggleGlass: this.props.onToggleUpGlass,
      listColor: this.listColor
    }), /*#__PURE__*/React.createElement(Rect, {
      x: measurements.doorFromLeft,
      y: this.doorFromCeiling(measurements) + measurements.doorHeight,
      width: measurements.doorWidth,
      height: measurements.height - this.doorFromCeiling(measurements) - measurements.doorHeight,
      fillLinearGradientStartPoint: {
        x: 0,
        y: 0
      },
      fillLinearGradientEndPoint: {
        x: 0,
        y: measurements.spaceUnderDoor
      },
      fillLinearGradientColorStops: [0, 'rgba(20,24,23,0.48)', 1, 'rgba(88,78,68,0.2)']
    }), /*#__PURE__*/React.createElement(MeasurementLine, {
      rotation: 0,
      y: 0,
      startx: measurements.doorFromLeft,
      length: measurements.doorWidth,
      showModal: this.props.showModal,
      lengthInputChanged: this.onDoorWidthChanged.bind(this),
      penIcon: this.props.penIcon,
      minValue: this.props.minDoorWidth,
      label: "Ovilehden aukon leveys"
    }), upperGlassHeightMeasurement(this, measurements, this.props), /*#__PURE__*/React.createElement(MeasurementLine, {
      ref: heightMeasurement => {
        this.doorHeightMeasurement = heightMeasurement;
      },
      rotation: -90,
      starty: this.doorFromCeiling(measurements) + measurements.doorHeight,
      startx: this.props.doorHeightMeasurementX,
      length: measurements.doorHeight,
      showModal: this.props.showModal,
      lengthInputChanged: this.props.doorHeightChanged.bind(this),
      penIcon: this.props.penIcon,
      minValue: this.props.minDoorHeight,
      label: "Ovilehden aukon korkeus"
    }), /*#__PURE__*/React.createElement(MeasurementLine, {
      lengthInputChanged: this.props.spaceUnderDoorChanged.bind(this),
      showModal: this.props.showModal,
      rotation: -90,
      starty: measurements.height,
      startx: this.props.spaceUnderDoorMeasurementX,
      length: parseInt(measurements.spaceUnderDoor),
      penIcon: this.props.penIcon,
      label: "Ilmarako"
    }), /*#__PURE__*/React.createElement(ChromeKnob, {
      y: measurements.upGlassHeight + measurements.doorHeight / 2,
      x: measurements.doorHandness == "left" || measurements.doorHandness == 0 ? measurements.doorFromLeft + parseInt(measurements.doorWidth) - 60 : measurements.doorFromLeft + 60,
      tone: this.listColor
    }));
  }
  doorFromCeiling(measurements) {
    if (measurements.upGlassEnabled) return measurements.upGlassHeight;else return measurements.height - measurements.doorHeight - measurements.spaceUnderDoor;
  }
  dragBoundHeightFunc(pos) {
    var relativePos = this.convertToRelativePosition(pos);
    relativePos.x = this.props.measurements.doorWidth / 2;
    let prerviousUpGlassHeight = this.upGlassheight;
    let newUpGlassheight = parseInt(prerviousUpGlassHeight + relativePos.y);
    if (newUpGlassheight < this.props.minUpGlassHeight) {
      relativePos.y += this.props.minUpGlassHeight - newUpGlassheight;
      newUpGlassheight = this.props.minUpGlassHeight;
    } else if (newUpGlassheight > this.props.maxUpGlassHeight) {
      relativePos.y -= newUpGlassheight - this.props.maxUpGlassHeight;
      newUpGlassheight = this.props.maxUpGlassHeight;
    }
    this.upGlassheight = newUpGlassheight;
    this.doorGlass.height(this.doorGlass.height() - (newUpGlassheight - prerviousUpGlassHeight));
    this.doorGlass.y(newUpGlassheight);
    this.heightMeasurement.setLength(newUpGlassheight, true);
    this.doorHeightMeasurement.setLength(this.doorGlass.height());
    return this.doorGlass.getAbsoluteTransform().point(relativePos);
  }
  onDragEnd(e) {
    if (this.props.doorHeightChanged) this.props.doorHeightChanged(this.doorGlass.height());
    if (this.props.upGlassHeightChanged) this.props.upGlassHeightChanged(this.upGlassheight);
  }
  onDoorWidthChanged(width) {
    if (this.props.onDoorWidthChanged) this.props.onDoorWidthChanged(width);
  }
  convertToRelativePosition(pos) {
    return this.doorGlass.getAbsoluteTransform().copy().invert().point(pos);
  }
}
let UpGlass = props => {
  const allowAddOrRemoveUpGlass = props.allowAddOrRemoveGlass && props.allowAddOrRemoveUpGlass;
  if (props.upGlassEnabled) return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(GlassPane, {
    width: props.width,
    height: props.height,
    y: 0,
    x: props.fromLeft,
    color: props.color
  }), /*#__PURE__*/React.createElement(MetalRail, {
    key: "upperList",
    width: props.width,
    height: 30,
    y: 0,
    x: props.fromLeft,
    tone: props.listColor
  }), removeUpGlassControl(props, allowAddOrRemoveUpGlass));else if (allowAddOrRemoveUpGlass) {
    return /*#__PURE__*/React.createElement(URLImage$1, {
      x: props.fromLeft + props.width / 2,
      y: 100,
      width: 200,
      height: 200,
      offsetX: 100,
      offsetY: 100,
      onTap: () => props.onToggleGlass(),
      onClick: () => props.onToggleGlass(),
      src: props.addGlass
    });
  } else {
    return null;
  }
};
let removeUpGlassControl = (props, allowAddOrRemoveUpGlass) => {
  if (allowAddOrRemoveUpGlass) {
    return /*#__PURE__*/React.createElement(URLImage$1, {
      x: props.fromLeft + props.width / 2,
      y: props.height / 2,
      width: 200,
      height: 200,
      offsetX: 100,
      offsetY: 100,
      onTap: () => props.onToggleGlass(),
      onClick: () => props.onToggleGlass(),
      src: props.removeGlass
    });
  } else {
    return null;
  }
};
let upperGlassHeightMeasurement = (sender, measurements, props) => {
  if (measurements.upGlassEnabled) {
    return /*#__PURE__*/React.createElement(MeasurementLine, {
      ref: heightMeasurement => {
        sender.heightMeasurement = heightMeasurement;
      },
      rotation: -90,
      starty: measurements.upGlassHeight,
      startx: props.upperGlassHeightMeasurementX,
      length: measurements.upGlassHeight,
      lengthInputChanged: props.upGlassHeightChanged.bind(sender),
      showModal: props.showModal,
      avoidOverFlow: true,
      penIcon: props.penIcon,
      label: "Yl\xE4lasin korkeus"
    });
  } else {
    return null;
  }
};
const defaultListColor$2 = "gray";

// Vertical measurement labels extend outward from their anchor. Keeping their
// anchors this far apart prevents the labels and dimension lines overlapping.
const verticalMeasurementSpacing = 120;

class sideGlass extends React.Component {
  constructor(props) {
    super();
    this.side = props.side;
  }
  render() {
    let component;
    const mayToggleSideGlass = this.props.allowAddOrRemoveGlass && (this.props.side === "left" ? this.props.allowAddOrRemoveLeftSideGlass : this.props.allowAddOrRemoveRightSideGlass);
    let addButonX = this.props.x;
    if (this.props.side == "left") addButonX += this.props.width - 150;else addButonX += 150;
    if (this.props.drawGlass) {
      let removeGlassElement;
      this.listColor = this.props.listColor || defaultListColor$1;
      if (mayToggleSideGlass) removeGlassElement = /*#__PURE__*/React.createElement(URLImage$1, {
        offsetX: 100,
        offsetY: 100,
        x: addButonX,
        y: this.props.height / 2,
        width: 200,
        height: 200,
        onTap: this.onToggleGlass.bind(this),
        onClick: this.onToggleGlass.bind(this),
        src: this.props.removeGlass
      });
      component = /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(GlassPane, {
        nodeRef: node => this.glassNode = node,
        width: this.props.width,
        height: this.props.height,
        y: this.props.upperEdge,
        x: this.props.x,
        color: this.props.color
      }), this.edges(this.props), /*#__PURE__*/React.createElement(MeasurementLine, {
        key: "widhtM",
        ref: widthMeasurement => {
          this.widthMeasurement = widthMeasurement;
        },
        startx: this.props.x,
        starty: 0,
        rotation: 0,
        lengthInputChanged: this.glassWidthInputChanged.bind(this),
        length: this.props.width,
        showModal: this.props.showModal,
        minValue: this.props.minWidth,
        maxValue: this.props.maxWidth,
        penIcon: this.props.penIcon,
        label: "Sivulasin aukon leveys"
      }), this.getHeightMeasurement(this.props), /*#__PURE__*/React.createElement(DragHandle, {
        axis: "vertical",
        dragBoundFunc: this.dragBoundHeightFunc.bind(this),
        onDragEnd: this.onHeightDragEnd.bind(this),
        x: this.props.x + this.props.width / 2,
        y: this.props.upperEdge + this.props.height
      }), this.getWidthControl(this.props), removeGlassElement);
    } else if (mayToggleSideGlass) {
      component = /*#__PURE__*/React.createElement(URLImage$1, {
        x: addButonX,
        y: this.props.height / 2,
        width: 200,
        height: 200,
        offsetX: 100,
        offsetY: 100,
        onTap: this.onToggleGlass.bind(this),
        onClick: this.onToggleGlass.bind(this),
        src: this.props.addGlass
      });
    } else component = /*#__PURE__*/React.createElement(Group, null);
    return component;
  }
  dragBoundHeightFunc(pos) {
    let relativePos = this.convertToRelativePosition(pos);
    relativePos.x = this.props.width / 2;
    let glassHeight = Math.min(Math.max(parseInt(relativePos.y), this.props.minHeight), this.props.maxHeight);
    relativePos.y = glassHeight;
    this.glassNode.height(glassHeight);
    this.heightMeasurement.setLength(parseInt(glassHeight), this.side === "left");
    return this.glassNode.getAbsoluteTransform().point(relativePos);
  }
  dragBoundWidthFunc(pos) {
    let relativePos = this.convertToRelativePosition(pos);
    relativePos.y = this.props.height / 2;
    if (this.side === "left") {
      let newWidth = this.glassNode.width() - relativePos.x;
      if (newWidth > this.props.maxWidth) {
        relativePos.x += newWidth - this.props.maxWidth;
      } else if (newWidth < this.props.minWidth) {
        relativePos.x -= this.props.minWidth - newWidth;
      }
      this.glassNode.x(this.glassNode.x() + relativePos.x);
      this.glassNode.width(this.glassNode.width() - relativePos.x);
    } else {
      let newWidth = relativePos.x;
      if (newWidth > this.props.maxWidth) {
        relativePos.x = this.props.maxWidth;
      } else if (newWidth < this.props.minWidth) {
        relativePos.x = this.props.minWidth;
      }
      this.glassNode.width(relativePos.x);
    }
    this.widthMeasurement.setLength(parseInt(this.glassNode.width()), this.side === "left");
    return this.glassNode.getAbsoluteTransform().point(relativePos);
  }
  onHeightDragEnd(evt) {
    if (this.props.heightChanged) {
      this.props.heightChanged(parseInt(this.glassNode.height()));
    }
  }
  onWidthDragEnd(evt) {
    if (this.props.widthChanged) {
      this.props.widthChanged(parseInt(this.glassNode.width()));
    }
  }
  onToggleGlass() {
    if (this.props.glassToggled) {
      this.props.glassToggled();
    }
  }
  convertToRelativePosition(pos) {
    return this.glassNode.getAbsoluteTransform().copy().invert().point(pos);
  }
  convertToAbsolutePosition(pos) {
    return this.glassNode.getAbsoluteTransform().point(pos);
  }
  getWidthControl(props) {
    let x = 0;
    if (this.side === "left") x = props.x;else x = this.props.x + props.width;
    return /*#__PURE__*/React.createElement(DragHandle, {
      axis: "horizontal",
      dragBoundFunc: this.dragBoundWidthFunc.bind(this),
      onDragEnd: this.onWidthDragEnd.bind(this),
      x: x,
      y: props.upperEdge + props.height / 2
    });
  }
  glassHeightInputChanged(glassHeight) {
    if (this.props.heightChanged) this.props.heightChanged(glassHeight);
  }
  glassWidthInputChanged(glassWidth) {
    if (this.props.widthChanged) this.props.widthChanged(glassWidth);
  }
  getHeightMeasurement(props) {
    let x = 0;
    let y = 0;
    let rotation = 0;
    if (this.side === "left") {
      x = props.x - verticalMeasurementSpacing;
      y = this.props.height + props.upperEdge;
      rotation = -90;
    } else {
      rotation = 90;
      x = this.props.x + props.width + verticalMeasurementSpacing;
      y = props.upperEdge;
    }
    return /*#__PURE__*/React.createElement(MeasurementLine, {
      minValue: this.props.minHeight,
      maxValue: this.props.maxHeight,
      ref: heightMeasurement => {
        this.heightMeasurement = heightMeasurement;
      },
      startx: x,
      starty: y,
      rotation: rotation,
      length: this.props.height,
      lengthInputChanged: this.glassHeightInputChanged.bind(this),
      showModal: this.props.showModal,
      label: "Sivulasin aukon korkeus",
      penIcon: props.penIcon
    });
  }
  edges(props) {
    let parts = [];
    const glassBottom = props.upperEdge + props.height;
    const hasBottomRail = props.lowerEdgeType == "list";
    if (props.side == "left") {
      parts.push(/*#__PURE__*/React.createElement(MetalRail, {
        key: "sidelist",
        width: listWidth,
        height: props.height,
        y: props.upperEdge,
        x: props.x,
        tone: this.listColor,
        startMiter: "right",
        endMiter: hasBottomRail ? "right" : undefined
      }));
    } else {
      parts.push(/*#__PURE__*/React.createElement(MetalRail, {
        key: "sidelist",
        width: listWidth,
        height: props.height,
        y: props.upperEdge,
        x: props.x + props.width - listWidth,
        tone: this.listColor,
        startMiter: "left",
        endMiter: hasBottomRail ? "left" : undefined
      }));
    }
    parts.push(/*#__PURE__*/React.createElement(MetalRail, {
      key: "upperList",
      width: props.width,
      height: listWidth,
      y: props.upperEdge,
      x: props.x,
      tone: this.listColor,
      startMiter: props.side == "left" ? "bottom" : undefined,
      endMiter: props.side == "right" ? "bottom" : undefined
    }));
    if (props.side == "left") parts.push(/*#__PURE__*/React.createElement(MiterJoint, {
      key: "upperMiter",
      points: [props.x, props.upperEdge, props.x + listWidth, props.upperEdge + listWidth]
    }));else parts.push(/*#__PURE__*/React.createElement(MiterJoint, {
      key: "upperMiter",
      points: [props.x + props.width, props.upperEdge, props.x + props.width - listWidth, props.upperEdge + listWidth]
    }));
    if (props.lowerEdgeType == "list") {
      parts.push(/*#__PURE__*/React.createElement(MetalRail, {
        key: "bottom",
        width: props.width,
        height: listWidth,
        y: props.upperEdge + props.height - listWidth,
        x: props.x,
        tone: this.listColor,
        startMiter: props.side == "left" ? "top" : undefined,
        endMiter: props.side == "right" ? "top" : undefined
      }));
      if (props.side == "left") parts.push(/*#__PURE__*/React.createElement(MiterJoint, {
        key: "lowerMiter",
        points: [props.x, glassBottom, props.x + listWidth, glassBottom - listWidth]
      }));else parts.push(/*#__PURE__*/React.createElement(MiterJoint, {
        key: "lowerMiter",
        points: [props.x + props.width, glassBottom, props.x + props.width - listWidth, glassBottom - listWidth]
      }));
    } else {
      let numberOfAttachments = Math.ceil(props.width / floorAttachmentTrsehold);
      if (numberOfAttachments == 1) {
        if (props.side == "left") parts.push(this.bottomAttachment(props.x + props.width - attachmentFromGlassEdge, props));else parts.push(this.bottomAttachment(props.x + attachmentFromGlassEdge, props));
      } else {
        let attachmenSpace = props.width - attachmentFromGlassEdge * 2;
        for (let i = 0; i < numberOfAttachments; i++) {
          parts.push(this.bottomAttachment(props.x + attachmentFromGlassEdge + i * attachmenSpace / (numberOfAttachments - 1), props));
        }
      }
    }
    return /*#__PURE__*/React.createElement(Group, null, parts);
  }
  bottomAttachment(position, props) {
    return /*#__PURE__*/React.createElement(ChromeHardware, {
      key: position,
      width: floorAttachmentSize,
      height: floorAttachmentSize,
      y: props.roomHeight - floorAttachmentSize,
      x: position - floorAttachmentSize / 2,
      tone: this.listColor
    });
  }
}
sideGlass.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  removeGlass: PropTypes.string.isRequired,
  addGlass: PropTypes.string.isRequired
};
const defaultListColor$1 = "gray";
const listWidth = 30;
const floorAttachmentSize = 48;
const floorAttachmentTrsehold = 600;
const attachmentFromGlassEdge = 100;

// :where() keeps the library defaults at zero specificity so consumer styles
// using any of the public classes below override them without !important.
const defaultStyles = `
:where(.glass-wall-measurement-panel) {
    border-top: 1px solid #dedbd5;
    background: #fff;
    color: #202020;
}
:where(.glass-wall-measurement-panel__toggle) {
    width: 100%; display: flex; align-items: center; justify-content: space-between;
    gap: 12px; padding: 16px 20px; border: 0; background: #fff; color: #202020;
    font: inherit; font-weight: 700; text-align: left; cursor: pointer;
}
:where(.glass-wall-measurement-panel__chevron) { font-size: 20px; line-height: 1; }
:where(.glass-wall-measurement-panel__fields) {
    display: flex; flex-direction: column; gap: 22px; padding: 4px 20px 22px;
}
:where(.glass-wall-measurement-panel__group) {
    display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
}
:where(.glass-wall-measurement-panel__group-title) {
    grid-column: 1 / -1; margin: 0 0 -4px; color: #202020;
    font-size: 15px; font-weight: 700;
}
:where(.glass-wall-measurement-panel__field) {
    display: flex; flex-direction: column; gap: 6px; min-width: 0;
}
:where(.glass-wall-measurement-panel__label) { font-size: 14px; font-weight: 600; }
:where(.glass-wall-measurement-panel__input-wrap) {
    display: flex; align-items: center; border: 1px solid #a9a6a0;
    border-radius: 8px; background: #fff; overflow: hidden;
}
:where(.glass-wall-measurement-panel__input-wrap--invalid) {
    border-color: #b42318; box-shadow: 0 0 0 1px #b42318;
}
:where(.glass-wall-measurement-panel__input) {
    width: 100%; min-width: 0; padding: 10px 12px; border: 0; outline: 0;
    font: inherit; color: #202020; background: transparent;
}
:where(.glass-wall-measurement-panel__unit) {
    padding-right: 12px; color: #66615a; font-size: 14px;
}
:where(.glass-wall-measurement-panel__hint) {
    min-height: 17px; margin: 0; color: #66615a; font-size: 12px;
}
:where(.glass-wall-measurement-panel__hint--error) { color: #b42318; }
`;
const finite = value => Number.isFinite(Number(value)) ? Number(value) : undefined;
function rangeText(min, max) {
  if (min !== undefined && max !== undefined) return `${min}–${max} mm`;
  if (min !== undefined) return `Vähintään ${min} mm`;
  if (max !== undefined) return `Enintään ${max} mm`;
  return '';
}
function MeasurementField(_ref) {
  let {
    field
  } = _ref;
  const [draft, setDraft] = React.useState(String(field.value));
  const [error, setError] = React.useState('');
  React.useEffect(() => {
    setDraft(String(field.value));
    setError('');
  }, [field.value]);
  const commit = () => {
    const value = Number(draft);
    if (draft.trim() === '' || !Number.isFinite(value)) {
      setError('Syötä kelvollinen mitta.');
      return;
    }
    if (field.min !== undefined && value < field.min) {
      setError(`Pienin sallittu mitta on ${field.min} mm.`);
      return;
    }
    if (field.max !== undefined && value > field.max) {
      setError(`Suurin sallittu mitta on ${field.max} mm.`);
      return;
    }
    setError('');
    field.onChange(value);
  };
  const inputId = `glass-wall-measurement-${field.key}`;
  const helpId = `${inputId}-help`;
  return /*#__PURE__*/React.createElement("div", {
    className: `glass-wall-measurement-panel__field glass-wall-measurement-panel__field--${field.key}`,
    "data-measurement": field.key
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: inputId,
    className: "glass-wall-measurement-panel__label"
  }, field.label), /*#__PURE__*/React.createElement("div", {
    className: `glass-wall-measurement-panel__input-wrap${error ? ' glass-wall-measurement-panel__input-wrap--invalid' : ''}`
  }, /*#__PURE__*/React.createElement("input", {
    id: inputId,
    type: "number",
    inputMode: "numeric",
    step: "1",
    min: field.min,
    max: field.max,
    value: draft,
    "aria-invalid": Boolean(error),
    "aria-describedby": helpId,
    className: "glass-wall-measurement-panel__input",
    onChange: event => {
      setDraft(event.target.value);
      setError('');
    },
    onBlur: commit,
    onKeyDown: event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        commit();
        event.currentTarget.blur();
      }
      if (event.key === 'Escape') {
        setDraft(String(field.value));
        setError('');
        event.currentTarget.blur();
      }
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "glass-wall-measurement-panel__unit"
  }, "mm")), /*#__PURE__*/React.createElement("p", {
    id: helpId,
    role: error ? 'alert' : undefined,
    className: `glass-wall-measurement-panel__hint${error ? ' glass-wall-measurement-panel__hint--error' : ''}`
  }, error || rangeText(field.min, field.max)));
}
function MeasurementPanel(_ref2) {
  let {
    measurements,
    limits = {},
    callbacks = {},
    showTotalGlassWallWidth
  } = _ref2;
  const [expanded, setExpanded] = React.useState(false);
  const number = key => finite(measurements[key]);
  const enabled = callback => typeof callback === 'function';
  const upGlassHeight = measurements.upGlassEnabled ? number('upGlassHeight') || 0 : 0;
  const maximumDoorHeight = Math.max(0, (number('height') || 0) - upGlassHeight);
  const maximumDoorWidth = Math.max(0, (number('doorWallWidth') || 0) - (number('doorFromLeft') || 0));
  const maximumDoorFromLeft = Math.max(0, (number('doorWallWidth') || 0) - (number('doorWidth') || 0));
  const maximumGap = Math.max(25, Math.min(250, (number('height') || 0) - upGlassHeight - (finite(limits.minDoorHeight) || 0)));
  const maximumUpGlassHeight = Math.min(finite(limits.maxUpGlassHeight) ?? Number.POSITIVE_INFINITY, Math.max(0, (number('height') || 0) - (number('spaceUnderDoor') || 0) - (finite(limits.minDoorHeight) || 0)));
  const hingesOnLeft = measurements.doorHandness === 'left' || measurements.doorHandness === 0;
  const leftSideGlassMinWidth = Math.max(finite(limits.leftSideGlassMinWidth) || 0, hingesOnLeft ? 250 : 150);
  const rightSideGlassMinWidth = Math.max(finite(limits.rightSideGlassMinWidth) || 0, hingesOnLeft ? 150 : 250);
  const totalGlassWidth = (number('doorWidth') || 0) + (measurements.leftSideGlassEnabled ? number('leftSideGlassWidth') || 0 : 0) + (measurements.rightSideGlassEnabled ? number('rightSideGlassWidth') || 0 : 0);
  const totalGlassMin = (number('doorWidth') || 0) + (measurements.leftSideGlassEnabled ? leftSideGlassMinWidth : 0) + (measurements.rightSideGlassEnabled ? rightSideGlassMinWidth : 0);
  const totalGlassMax = (number('doorWidth') || 0) + (measurements.leftSideGlassEnabled ? finite(limits.leftSideGlassMaxWidth) || 0 : 0) + (measurements.rightSideGlassEnabled ? finite(limits.rightSideGlassMaxWidth) || 0 : 0);
  const fields = [enabled(callbacks.wallWidthChanged) && {
    group: 'door',
    key: 'wall-width',
    label: 'Seinän leveys',
    value: number('doorWallWidth'),
    min: (number('doorFromLeft') || 0) + (number('doorWidth') || 0),
    onChange: callbacks.wallWidthChanged
  }, enabled(callbacks.wallHeightChanged) && {
    group: 'door',
    key: 'wall-height',
    label: 'Seinän korkeus',
    value: number('height'),
    min: (number('doorHeight') || 0) + (number('spaceUnderDoor') || 0) + upGlassHeight,
    onChange: callbacks.wallHeightChanged
  }, enabled(callbacks.doorFromLeftChanged) && {
    group: 'door',
    key: 'door-from-left',
    label: 'Oven sijainti vasemmalta',
    value: number('doorFromLeft'),
    min: 0,
    max: maximumDoorFromLeft,
    onChange: callbacks.doorFromLeftChanged
  }, showTotalGlassWallWidth && enabled(callbacks.totalWidthChanged) && {
    group: 'door',
    key: 'total-glass-width',
    label: 'Lasiseinän kokonaisleveys',
    value: totalGlassWidth,
    min: totalGlassMin,
    max: totalGlassMax,
    onChange: callbacks.totalWidthChanged
  }, enabled(callbacks.onDoorWidthChanged) && {
    group: 'door',
    key: 'door-width',
    label: 'Ovilehden leveys',
    value: number('doorWidth'),
    min: finite(limits.minDoorWidth),
    max: maximumDoorWidth,
    onChange: callbacks.onDoorWidthChanged
  }, enabled(callbacks.doorHeightChanged) && {
    group: 'door',
    key: 'door-height',
    label: 'Ovilehden korkeus',
    value: number('doorHeight'),
    min: finite(limits.minDoorHeight),
    max: maximumDoorHeight,
    onChange: callbacks.doorHeightChanged
  }, enabled(callbacks.spaceUnderDoorChanged) && {
    group: 'door',
    key: 'space-under-door',
    label: 'Ilmarako oven alla',
    value: number('spaceUnderDoor'),
    min: 25,
    max: maximumGap,
    onChange: callbacks.spaceUnderDoorChanged
  }, measurements.upGlassEnabled && enabled(callbacks.upGlassHeightChanged) && {
    group: 'door',
    key: 'up-glass-height',
    label: 'Ylälasin korkeus',
    value: number('upGlassHeight'),
    min: finite(limits.minUpGlassHeight),
    max: maximumUpGlassHeight,
    onChange: callbacks.upGlassHeightChanged
  }, measurements.leftSideGlassEnabled && enabled(callbacks.leftSideGlassWidthChanged) && {
    group: 'left',
    key: 'left-glass-width',
    label: 'Leveys',
    value: number('leftSideGlassWidth'),
    min: leftSideGlassMinWidth,
    max: finite(limits.leftSideGlassMaxWidth),
    onChange: callbacks.leftSideGlassWidthChanged
  }, measurements.leftSideGlassEnabled && enabled(callbacks.leftSideGlassHeightChanged) && {
    group: 'left',
    key: 'left-glass-height',
    label: 'Korkeus',
    value: number('leftSideGlassHeight'),
    min: finite(limits.leftSideGlassMinHeight),
    max: finite(limits.leftSideGlassMaxHeight),
    onChange: callbacks.leftSideGlassHeightChanged
  }, measurements.rightSideGlassEnabled && enabled(callbacks.rightSideGlassWidthChanged) && {
    group: 'right',
    key: 'right-glass-width',
    label: 'Leveys',
    value: number('rightSideGlassWidth'),
    min: rightSideGlassMinWidth,
    max: finite(limits.rightSideGlassMaxWidth),
    onChange: callbacks.rightSideGlassWidthChanged
  }, measurements.rightSideGlassEnabled && enabled(callbacks.rightSideGlassHeightChanged) && {
    group: 'right',
    key: 'right-glass-height',
    label: 'Korkeus',
    value: number('rightSideGlassHeight'),
    min: finite(limits.rightSideGlassMinHeight),
    max: finite(limits.rightSideGlassMaxHeight),
    onChange: callbacks.rightSideGlassHeightChanged
  }].filter(Boolean).filter(field => field.value !== undefined);
  const groups = [{
    key: 'door',
    title: 'Oven sijainti ja koko'
  }, {
    key: 'left',
    title: 'Vasemman sivulasin koko'
  }, {
    key: 'right',
    title: 'Oikean sivulasin koko'
  }].map(group => ({
    ...group,
    fields: fields.filter(field => field.group === group.key)
  })).filter(group => group.fields.length);
  if (!fields.length) return null;
  return /*#__PURE__*/React.createElement("section", {
    className: `glass-wall-measurement-panel${expanded ? ' glass-wall-measurement-panel--expanded' : ' glass-wall-measurement-panel--collapsed'}`,
    "aria-label": "Lasisein\xE4n mitat"
  }, /*#__PURE__*/React.createElement("style", null, defaultStyles), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "glass-wall-measurement-panel__toggle",
    "aria-expanded": expanded,
    "aria-controls": "glass-wall-measurement-fields",
    onClick: () => setExpanded(value => !value)
  }, /*#__PURE__*/React.createElement("span", {
    className: "glass-wall-measurement-panel__toggle-label"
  }, "Muuta lasisein\xE4n mitoitusta k\xE4sin"), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: "glass-wall-measurement-panel__chevron"
  }, expanded ? '−' : '+')), expanded && /*#__PURE__*/React.createElement("div", {
    id: "glass-wall-measurement-fields",
    className: "glass-wall-measurement-panel__fields"
  }, groups.map(group => /*#__PURE__*/React.createElement("div", {
    key: group.key,
    className: `glass-wall-measurement-panel__group glass-wall-measurement-panel__group--${group.key}`
  }, /*#__PURE__*/React.createElement("h3", {
    className: "glass-wall-measurement-panel__group-title"
  }, group.title), group.fields.map(field => /*#__PURE__*/React.createElement(MeasurementField, {
    key: field.key,
    field: field
  }))))));
}

const modalStyle = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
};
const offset = 250;
class glassWall extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
    this.ref = /*#__PURE__*/React.createRef();
    this.widthAnimationFrame = null;
    this.scheduleWidthUpdate = this.scheduleWidthUpdate.bind(this);
    this.updateWidth = this.updateWidth.bind(this);
  }
  render() {
    const measurements = this.props.measurements;
    const wallWidth = Number(measurements.doorWallWidth);
    const verticalMeasurementPositions = this.leftVerticalMeasurementPositions(measurements);
    const leftPadding = Math.max(offset, offset - verticalMeasurementPositions.totalHeight);
    let rightmostMeasurementEdge = wallWidth + offset;
    if (measurements.rightSideGlassEnabled) {
      rightmostMeasurementEdge = Math.max(rightmostMeasurementEdge, this.rightSideGlassHeightMeasurementX(measurements) + verticalMeasurementSpacing);
    }
    let neededWidth = leftPadding + rightmostMeasurementEdge;
    let neededHeight = 2.5 * offset + parseInt(this.props.measurements.height);
    this.listColor = this.props.listColor || defaultListColor;
    let scale = 1;
    if (Number.isFinite(this.state.width) && this.state.width > 0) {
      scale = this.state.width / neededWidth;
    }
    let upperEdge = this.props.measurements.upGlassEnabled ? 0 : this.props.measurements.height - this.props.measurements.spaceUnderDoor - this.props.measurements.doorHeight;
    let component;
    if (this.props.measurements.doorWallWidth && this.props.measurements.height) {
      component = /*#__PURE__*/React.createElement("div", {
        ref: this.ref,
        className: "glassWallRender"
      }, /*#__PURE__*/React.createElement(Stage, {
        height: neededHeight * scale,
        width: neededWidth * scale,
        scaleY: scale,
        scaleX: scale
      }, /*#__PURE__*/React.createElement(Layer, null, /*#__PURE__*/React.createElement(Rect, {
        width: neededWidth,
        height: neededHeight,
        fill: "#f3f1ec"
      }), /*#__PURE__*/React.createElement(Rect, {
        x: leftPadding,
        y: offset,
        width: this.props.measurements.doorWallWidth,
        height: this.props.measurements.height,
        fillLinearGradientStartPoint: {
          x: 0,
          y: 0
        },
        fillLinearGradientEndPoint: {
          x: 0,
          y: this.props.measurements.height
        },
        fillLinearGradientColorStops: [0, '#eeeae3', 0.58, '#e2ddd4', 1, '#cfc8bc'],
        shadowColor: "rgba(34,31,28,0.28)",
        shadowBlur: 22,
        shadowOffset: {
          x: 0,
          y: 10
        }
      }), /*#__PURE__*/React.createElement(Group, {
        x: leftPadding,
        y: offset
      }, this.props.background && /*#__PURE__*/React.createElement(URLImage$1, {
        src: this.props.background,
        x: 0,
        y: 0,
        width: this.props.measurements.doorWallWidth,
        height: this.props.measurements.height
      }), /*#__PURE__*/React.createElement(Group, {
        clipFunc: this.glassClipFunc.bind(this)
      }, /*#__PURE__*/React.createElement(Rect, {
        width: this.props.measurements.doorWallWidth,
        height: this.props.measurements.height,
        fillLinearGradientStartPoint: {
          x: 0,
          y: 0
        },
        fillLinearGradientEndPoint: {
          x: 0,
          y: this.props.measurements.height
        },
        fillLinearGradientColorStops: [0, '#eeeae3', 0.58, '#e2ddd4', 1, '#cfc8bc']
      })), /*#__PURE__*/React.createElement(Rect, {
        ref: layer => {
          this.testlayer = layer;
        },
        width: this.props.measurements.doorWallWidth,
        height: this.props.measurements.height,
        strokeWidth: 4,
        stroke: "#8a9697"
      }), !this.props.hideDoorFromLeftMeasurement && /*#__PURE__*/React.createElement(MeasurementLine, {
        startx: 0,
        length: this.props.measurements.doorFromLeft,
        starty: this.props.measurements.height + offset,
        label: "Ovi vasemmalta",
        lengthInputChanged: this.props.doorFromLeftChanged ? this.props.doorFromLeftChanged.bind(this) : undefined,
        showModal: this.showMeasurementModal.bind(this),
        penIcon: this.props.penIcon
      }), this.totalGlassWidthMeasurementLine(this.props), this.totalWallWidthMeasurementLine(this.props), this.totalHeightMeasurementLine(this.props, verticalMeasurementPositions.totalHeight), /*#__PURE__*/React.createElement(door, {
        measurements: this.props.measurements,
        doorHeightChanged: this.props.doorHeightChanged,
        onDoorWidthChanged: this.props.onDoorWidthChanged,
        upGlassHeightChanged: this.props.upGlassHeightChanged,
        spaceUnderDoorChanged: this.props.spaceUnderDoorChanged,
        color: this.props.glassColor,
        minUpGlassHeight: this.props.glassSizeLimits.minUpGlassHeight,
        maxUpGlassHeight: this.props.glassSizeLimits.maxUpGlassHeight,
        minDoorWidth: this.props.glassSizeLimits.minDoorWidth,
        minDoorHeight: this.props.glassSizeLimits.minDoorHeight,
        showModal: this.showMeasurementModal.bind(this),
        allowAddOrRemoveGlass: this.props.glassSizeLimits.allowAddOrRemoveGlass,
        allowAddOrRemoveUpGlass: this.props.glassSizeLimits.allowAddOrRemoveUpGlass,
        removeGlass: this.props.removeGlass,
        addGlass: this.props.addGlass,
        penIcon: this.props.penIcon,
        onToggleUpGlass: this.props.upGlassToggled,
        doorHeightMeasurementX: verticalMeasurementPositions.doorHeight,
        upperGlassHeightMeasurementX: verticalMeasurementPositions.upperGlassHeight,
        spaceUnderDoorMeasurementX: verticalMeasurementPositions.spaceUnderDoor,
        listColor: this.listColor
      }), /*#__PURE__*/React.createElement(sideGlass, {
        side: "left",
        heightChanged: this.props.leftSideGlassHeightChanged,
        widthChanged: this.props.leftSideGlassWidthChanged,
        glassToggled: this.props.leftSideGlassToggled,
        drawGlass: this.props.measurements.leftSideGlassEnabled,
        x: this.props.measurements.doorFromLeft - this.props.measurements.leftSideGlassWidth,
        width: this.props.measurements.leftSideGlassWidth,
        minWidth: this.props.glassSizeLimits.leftSideGlassMinWidth,
        maxWidth: this.props.glassSizeLimits.leftSideGlassMaxWidth,
        height: this.props.measurements.leftSideGlassHeight,
        minHeight: this.props.glassSizeLimits.leftSideGlassMinHeight,
        maxHeight: this.props.glassSizeLimits.leftSideGlassMaxHeight,
        roomHeight: this.props.measurements.height,
        color: this.props.glassColor,
        removeGlass: this.props.removeGlass,
        addGlass: this.props.addGlass,
        verticalArrows: this.props.verticalArrows,
        horizontalArrows: this.props.horizontalArrows,
        showModal: this.showMeasurementModal.bind(this),
        allowAddOrRemoveGlass: this.props.glassSizeLimits.allowAddOrRemoveGlass,
        allowAddOrRemoveLeftSideGlass: this.props.glassSizeLimits.allowAddOrRemoveLeftSideGlass,
        penIcon: this.props.penIcon,
        upperEdge: upperEdge,
        lowerEdgeType: this.lowerEdgeType(this.props.measurements.height - upperEdge - this.props.measurements.leftSideGlassHeight),
        listColor: this.listColor
      }), /*#__PURE__*/React.createElement(sideGlass, {
        side: "right",
        heightChanged: this.props.rightSideGlassHeightChanged,
        widthChanged: this.props.rightSideGlassWidthChanged,
        glassToggled: this.props.rightSideGlassToggled,
        drawGlass: this.props.measurements.rightSideGlassEnabled,
        x: this.props.measurements.doorFromLeft + parseInt(this.props.measurements.doorWidth),
        width: this.props.measurements.rightSideGlassWidth,
        minWidth: this.props.glassSizeLimits.rightSideGlassMinWidth,
        maxWidth: this.props.glassSizeLimits.rightSideGlassMaxWidth,
        height: this.props.measurements.rightSideGlassHeight,
        roomHeight: this.props.measurements.height,
        minHeight: this.props.glassSizeLimits.rightSideGlassMinHeight,
        maxHeight: this.props.glassSizeLimits.rightSideGlassMaxHeight,
        color: this.props.glassColor,
        removeGlass: this.props.removeGlass,
        addGlass: this.props.addGlass,
        verticalArrows: this.props.verticalArrows,
        horizontalArrows: this.props.horizontalArrows,
        showModal: this.showMeasurementModal.bind(this),
        allowAddOrRemoveGlass: this.props.glassSizeLimits.allowAddOrRemoveGlass,
        allowAddOrRemoveRightSideGlass: this.props.glassSizeLimits.allowAddOrRemoveRightSideGlass,
        penIcon: this.props.penIcon,
        upperEdge: upperEdge,
        lowerEdgeType: this.lowerEdgeType(this.props.measurements.height - upperEdge - this.props.measurements.rightSideGlassHeight),
        listColor: this.listColor
      }), this.hinges(this.props.measurements), this.upperGlassBushings(this.props.measurements)))), /*#__PURE__*/React.createElement(MeasurementPanel, {
        measurements: this.props.measurements,
        limits: this.props.glassSizeLimits,
        showTotalGlassWallWidth: this.props.showTotalGlassWallWidth,
        callbacks: {
          wallWidthChanged: this.props.wallWidthChanged,
          wallHeightChanged: this.props.wallHeightChanged,
          doorFromLeftChanged: this.props.doorFromLeftChanged,
          totalWidthChanged: this.props.totalWidthChanged,
          onDoorWidthChanged: this.props.onDoorWidthChanged,
          doorHeightChanged: this.props.doorHeightChanged,
          spaceUnderDoorChanged: this.props.spaceUnderDoorChanged,
          upGlassHeightChanged: this.props.upGlassHeightChanged,
          leftSideGlassWidthChanged: this.props.leftSideGlassWidthChanged,
          leftSideGlassHeightChanged: this.props.leftSideGlassHeightChanged,
          rightSideGlassWidthChanged: this.props.rightSideGlassWidthChanged,
          rightSideGlassHeightChanged: this.props.rightSideGlassHeightChanged
        }
      }), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.showModal,
        style: modalStyle
      }, /*#__PURE__*/React.createElement("label", null, this.state.modalLabel), /*#__PURE__*/React.createElement("input", {
        type: "number",
        defaultValue: this.state.modalValue,
        onChange: sender => this.modalInputChanged(this.clamp(parseInt(sender.target.value) || 0, this.state.modalMinValue, this.state.modalMaxValue)),
        min: this.state.modalMinValue,
        max: this.state.modalMaxValue
      }), /*#__PURE__*/React.createElement("button", {
        onClick: this.closeModal.bind(this)
      }, "Sulje")));
    } else component = /*#__PURE__*/React.createElement("div", {
      ref: this.ref
    });
    return component;
  }
  hinges(measurements) {
    let upperEdge = measurements.height - measurements.spaceUnderDoor - measurements.doorHeight;
    let upperHinge = upperEdge + hingeFromEdge;
    let lowerHinge = upperEdge + measurements.doorHeight - hingeFromEdge;
    if (measurements.doorHandness == "left" || measurements.doorHandness == 0) {
      let sideGlassPoint = 0;
      if (measurements.leftSideGlassEnabled) {
        if (measurements.upGlassEnabled) sideGlassPoint = measurements.leftSideGlassHeight;else sideGlassPoint = upperEdge + measurements.leftSideGlassHeight;
      }
      let bottomHingeHalfHinge = sideGlassPoint < lowerHinge;
      let upperHingeHalfHinge = sideGlassPoint < upperHinge;
      return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(ChromeHinge, {
        x: measurements.doorFromLeft - (upperHingeHalfHinge ? 0 : hingeWidth / 2),
        y: upperHinge - hingeHeight / 2,
        width: upperHingeHalfHinge ? hingeWidth / 2 : hingeWidth,
        height: hingeHeight,
        half: upperHingeHalfHinge,
        tone: this.listColor
      }), /*#__PURE__*/React.createElement(ChromeHinge, {
        x: measurements.doorFromLeft - (bottomHingeHalfHinge ? 0 : hingeWidth / 2),
        y: lowerHinge - hingeHeight / 2,
        width: bottomHingeHalfHinge ? hingeWidth / 2 : hingeWidth,
        height: hingeHeight,
        half: bottomHingeHalfHinge,
        tone: this.listColor
      }));
    } else {
      let sideGlassPoint = 0;
      if (measurements.rightSideGlassEnabled) {
        if (measurements.upGlassEnabled) sideGlassPoint = measurements.rightSideGlassHeight;else sideGlassPoint = upperEdge + measurements.rightSideGlassHeight;
      }
      let bottomHingeHalfHinge = sideGlassPoint < lowerHinge;
      let upperHingeHalfHinge = sideGlassPoint < upperHinge;
      return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(ChromeHinge, {
        x: measurements.doorFromLeft + measurements.doorWidth - hingeWidth / 2,
        y: upperHinge - hingeHeight / 2,
        width: upperHingeHalfHinge ? hingeWidth / 2 : hingeWidth,
        height: hingeHeight,
        half: upperHingeHalfHinge,
        tone: this.listColor
      }), /*#__PURE__*/React.createElement(ChromeHinge, {
        x: measurements.doorFromLeft + measurements.doorWidth - hingeWidth / 2,
        y: lowerHinge - hingeHeight / 2,
        width: bottomHingeHalfHinge ? hingeWidth / 2 : hingeWidth,
        height: hingeHeight,
        half: bottomHingeHalfHinge,
        tone: this.listColor
      }));
    }
  }
  upperGlassBushings(measurements) {
    if (!measurements.upGlassEnabled) return null;
    const upperGlassHeight = Number(measurements.upGlassHeight) || 0;
    const bushingCenterY = upperGlassHeight < 200 ? upperGlassHeight / 2 : bushingFromTop;
    const leftAttachedToGlass = measurements.leftSideGlassEnabled && Number(measurements.leftSideGlassHeight) >= bushingCenterY;
    const rightAttachedToGlass = measurements.rightSideGlassEnabled && Number(measurements.rightSideGlassHeight) >= bushingCenterY;
    const leftWidth = leftAttachedToGlass ? hingeWidth : hingeWidth / 2;
    const rightWidth = rightAttachedToGlass ? hingeWidth : hingeWidth / 2;
    return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(ChromeHinge, {
      x: measurements.doorFromLeft - (leftAttachedToGlass ? hingeWidth / 2 : 0),
      y: bushingCenterY - bushingHeight / 2,
      width: leftWidth,
      height: bushingHeight,
      half: !leftAttachedToGlass,
      tone: this.listColor
    }), /*#__PURE__*/React.createElement(ChromeHinge, {
      x: measurements.doorFromLeft + measurements.doorWidth - hingeWidth / 2,
      y: bushingCenterY - bushingHeight / 2,
      width: rightWidth,
      height: bushingHeight,
      half: !rightAttachedToGlass,
      tone: this.listColor
    }));
  }
  clamp(value, min, max) {
    if (value < min || Number.isNaN(value)) value = min;else if (value > max) value = max;
    return value;
  }
  componentDidMount() {
    if (this.testlayer) this.testlayer.globalCompositeOperation("source-over");
    this.updateWidth();
    if (typeof ResizeObserver === "function") {
      this.resizeObserver = new ResizeObserver(this.scheduleWidthUpdate);
      if (this.ref.current) {
        this.resizeObserver.observe(this.ref.current);
      }
    }
    window.addEventListener("resize", this.scheduleWidthUpdate);
  }
  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener("resize", this.scheduleWidthUpdate);
    if (this.widthAnimationFrame !== null && typeof window.cancelAnimationFrame === "function") {
      window.cancelAnimationFrame(this.widthAnimationFrame);
    }
  }
  scheduleWidthUpdate() {
    if (this.widthAnimationFrame !== null) return;
    if (typeof window.requestAnimationFrame !== "function") {
      this.updateWidth();
      return;
    }
    this.widthAnimationFrame = window.requestAnimationFrame(() => {
      this.widthAnimationFrame = null;
      this.updateWidth();
    });
  }
  updateWidth() {
    const control = this.ref.current;
    if (!control) return;
    const boundingWidth = typeof control.getBoundingClientRect === "function" ? control.getBoundingClientRect().width : 0;
    const width = control.clientWidth || boundingWidth || control.offsetWidth;
    if (!Number.isFinite(width) || width <= 0) return;
    this.setState(prevState => {
      if (prevState.width === width) return null;
      return {
        width
      };
    });
  }
  showMeasurementModal(label, value, onchanged, minValue, maxValue) {
    this.setState({
      showModal: true,
      modalValue: value,
      modalLabel: label,
      modalMinValue: minValue,
      modalMaxValue: maxValue
    });
    this.modalInputChanged = onchanged;
  }
  closeModal() {
    this.setState({
      showModal: false
    });
  }
  glassClipFunc(ctx) {
    let measurements = this.props.measurements;
    let upperEdge = measurements.upGlassEnabled ? 0 : measurements.height - measurements.spaceUnderDoor - measurements.doorHeight;
    ctx.rect(0, 0, measurements.doorWallWidth, upperEdge);
    if (measurements.doorFromLeft > 0) {
      if (measurements.leftSideGlassEnabled) {
        if (measurements.leftSideGlassWidth < measurements.doorFromLeft) {
          ctx.rect(0, 0, measurements.doorFromLeft - measurements.leftSideGlassWidth, measurements.height);
        }
        let arealeftPoint = Math.max(0, measurements.doorFromLeft - measurements.leftSideGlassWidth);
        ctx.rect(arealeftPoint, measurements.leftSideGlassHeight + upperEdge, measurements.doorFromLeft - arealeftPoint, upperEdge + measurements.height - measurements.leftSideGlassHeight);
      } else {
        ctx.rect(0, upperEdge, measurements.doorFromLeft, measurements.height);
      }
    }
    if (measurements.doorWallWidth > measurements.doorFromLeft + measurements.doorWidth) {
      if (measurements.rightSideGlassEnabled) {
        let rightSideGlassEdgeFromRight = measurements.doorWallWidth - measurements.doorFromLeft - measurements.doorWidth - measurements.rightSideGlassWidth;
        if (rightSideGlassEdgeFromRight > 0) {
          ctx.rect(measurements.doorWallWidth - rightSideGlassEdgeFromRight, upperEdge, rightSideGlassEdgeFromRight, measurements.height);
        }
        Math.min(measurements.doorWallWidth, measurements.doorWallWidth - rightSideGlassEdgeFromRight);
        ctx.rect(measurements.doorFromLeft + measurements.doorWidth, measurements.rightSideGlassHeight + upperEdge, measurements.rightSideGlassWidth, measurements.height - measurements.rightSideGlassHeight);
      } else {
        ctx.rect(measurements.doorFromLeft + measurements.doorWidth, 0, measurements.doorWallWidth - measurements.doorFromLeft - measurements.doorWidth, measurements.height);
      }
    }
  }
  totalGlassWidthMeasurementLine(props) {
    let measurements = props.measurements;
    if ((measurements.leftSideGlassEnabled || measurements.rightSideGlassEnabled) && props.showTotalGlassWallWidth) {
      let start = measurements.leftSideGlassEnabled ? measurements.doorFromLeft - measurements.leftSideGlassWidth : measurements.doorFromLeft;
      let length = measurements.doorWidth;
      if (measurements.leftSideGlassEnabled) length += measurements.leftSideGlassWidth;
      if (measurements.rightSideGlassEnabled) length += measurements.rightSideGlassWidth;
      return /*#__PURE__*/React.createElement(MeasurementLine, {
        startx: start,
        length: length,
        starty: -offset / 2,
        label: "Kokonaisleveys",
        lengthInputChanged: this.props.totalWidthChange ? this.props.totalWidthChanged.bind(this) : undefined,
        showModal: this.showMeasurementModal.bind(this),
        penIcon: props.penIcon
      });
    } else return /*#__PURE__*/React.createElement(Group, null);
  }
  totalWallWidthMeasurementLine(props) {
    if (props.showWallMeasurements) {
      let measurements = props.measurements;
      let length = measurements.doorWallWidth;
      return /*#__PURE__*/React.createElement(MeasurementLine, {
        startx: 0,
        length: length,
        starty: -offset / 2,
        label: "Leveys",
        lengthInputChanged: this.props.wallWidthChanged ? this.props.wallWidthChanged.bind(this) : undefined,
        showModal: this.showMeasurementModal.bind(this),
        penIcon: props.penIcon
      });
    } else return /*#__PURE__*/React.createElement(Group, null);
  }
  totalHeightMeasurementLine(props, startx) {
    if (props.showWallMeasurements) {
      let measurements = props.measurements;
      let length = measurements.height;
      return /*#__PURE__*/React.createElement(MeasurementLine, {
        rotation: -90,
        startx: startx,
        length: length,
        starty: length,
        label: "Korkeus",
        lengthInputChanged: this.props.wallHeightChanged ? this.props.wallHeightChanged.bind(this) : undefined,
        showModal: this.showMeasurementModal.bind(this),
        penIcon: props.penIcon
      });
    } else return /*#__PURE__*/React.createElement(Group, null);
  }
  leftVerticalMeasurementPositions(measurements) {
    const leftGlassEdge = measurements.leftSideGlassEnabled ? Number(measurements.doorFromLeft) - Number(measurements.leftSideGlassWidth) : 0;
    const leftSideGlassMeasurementX = leftGlassEdge - verticalMeasurementSpacing;
    const innermostLane = Math.min(0, leftSideGlassMeasurementX) - verticalMeasurementSpacing;
    return {
      spaceUnderDoor: innermostLane,
      doorHeight: innermostLane,
      upperGlassHeight: innermostLane,
      totalHeight: innermostLane - verticalMeasurementSpacing
    };
  }
  rightSideGlassHeightMeasurementX(measurements) {
    return Number(measurements.doorFromLeft) + Number(measurements.doorWidth) + Number(measurements.rightSideGlassWidth) + verticalMeasurementSpacing;
  }
  lowerEdgeType(space) {
    return space <= minListBottomEdgeHeight ? "floorAttachment" : "list";
  }
}
const defaultListColor = "gray";
const minListBottomEdgeHeight = 25;
const hingeWidth = 115;
const hingeHeight = 90;
const bushingHeight = hingeHeight / 2;
const bushingFromTop = 100;
const hingeFromEdge = 283;

const getLimits = measurements => {
  const hingesOnLeft = measurements.doorHandness === "left" || measurements.doorHandness === 0;
  const rightSideGlassMaxWidth = Math.max(0, measurements.doorWallWidth - measurements.doorFromLeft - measurements.doorWidth + sideGlassOutsideRoomAllowance);
  const leftSideGlassMaxWidth = Math.max(0, measurements.doorFromLeft + sideGlassOutsideRoomAllowance);
  const availableUpGlassHeight = measurements.height - defaultDoorHeight - defaultSpaceUnderDoor;
  let limits = {
    rightSideGlassMinHeight: minSideGlassHeight,
    rightSideGlassMaxHeight: measurements.upGlassEnabled ? measurements.height : measurements.doorHeight + measurements.spaceUnderDoor,
    rightSideGlassMinWidth: hingesOnLeft ? minSideGlassWidth : minHingeGlassWidth,
    rightSideGlassMaxWidth: rightSideGlassMaxWidth,
    leftSideGlassMaxHeight: measurements.upGlassEnabled ? measurements.height : measurements.doorHeight + measurements.spaceUnderDoor,
    leftSideGlassMinHeight: minSideGlassHeight,
    leftSideGlassMaxWidth: leftSideGlassMaxWidth,
    leftSideGlassMinWidth: hingesOnLeft ? minHingeGlassWidth : minSideGlassWidth,
    minUpGlassHeight: minUpGlassHeight,
    maxUpGlassHeight: maxUpGlassHeight,
    minDoorWidth: minDoorWidth,
    minDoorHeight: minDoorHeight,
    allowAddOrRemoveGlass: true,
    allowAddOrRemoveLeftSideGlass: leftSideGlassMaxWidth > 0,
    allowAddOrRemoveRightSideGlass: rightSideGlassMaxWidth > 0,
    allowAddOrRemoveUpGlass: availableUpGlassHeight >= minUpGlassHeight
  };
  return limits;
};
const sideGlassOutsideRoomAllowance = 100;
const minSideGlassWidth = 150;
const minHingeGlassWidth = 250;
const minUpGlassHeight = 100;
const maxUpGlassHeight = 500;
const minSideGlassHeight = 300;
const minDoorWidth = 600;
const minDoorHeight = 1500;
const defaultDoorHeight = 1850;
const defaultSpaceUnderDoor = 150;

export { glassWall as GlassWallComponent, getLimits };
